import { MutableRefObject, RefObject, useEffect, useRef } from 'react';

export type ClickOutsideCallback = (event: MouseEvent) => void;

export const useClickOutside = <T extends Node>(
  onDetect: ClickOutsideCallback,
  includeTooltip?: boolean,
  eventListenerOptions?: AddEventListenerOptions,
  ref?: MutableRefObject<T>,
): RefObject<T> => {
  const innerRef: RefObject<T> = useRef<T>(null);

  const refToUse = ref ? ref : innerRef;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const onTooltipClick = event.composedPath().some((target: Element) => {
        return target.className === 'react-tiny-popover-container';
      });
      if (
        refToUse.current &&
        !refToUse.current.contains(event.target as HTMLElement) &&
        !(includeTooltip && onTooltipClick)
      ) {
        onDetect(event);
      }
    };

    document.addEventListener(
      'mousedown',
      handleClickOutside,
      eventListenerOptions,
    );

    return () => {
      document.removeEventListener(
        'mousedown',
        handleClickOutside,
        eventListenerOptions,
      );
    };
  }, [refToUse, onDetect, includeTooltip, eventListenerOptions]);

  return refToUse;
};
